module.exports = __webpack_public_path__ + "img/introduce-6.a6318362.png";